<template lang="">
  <div>
    <!-- 企业认证表单 -->
    <div class="certForm" v-loading="loading">
      <el-alert v-if="status==4" :title="'认证不通过的原因：'+certForm.cause" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
      <el-alert v-if="status==3" title="您的企业认证已完成" type="success" :closable="false" style="margin-bottom:20px;"></el-alert>
      <el-alert v-if="status==2" title="您的资料正在审核，请稍等" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>
      <el-form ref="certForm" :model="certForm" label-width="130px" size="small">
        <el-form-item label="公司名称" class="formWidth" prop="company" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-input v-model="certForm.company" placeholder="请输入营业执照上的名称，如“北京xx股份有限公司”" :disabled='(status==2||status==3)?true:false' ></el-input>
        </el-form-item>
        <el-form-item label="公司简称" class="formWidth" prop="abbreviation" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-input v-model="certForm.abbreviation" placeholder="请输入企业较为广为人知的简称，如“经济观察报”" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item>
        <el-form-item label="企业logo" class="formWidth" prop="filelogo" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-upload class="avatar-uploader" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :show-file-list="false" :http-request="changeImageUpload" :before-upload="handleBeforeUpload" :disabled='(status==2||status==3)?true:false'>
            <el-image v-if="certForm.filelogo" class="avatar" :src="imgBase+certForm.filelogo" fit="scale-down"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="placeholder">要求：请上传格式为jpg、jpeg、png、gif，小于1MB的图片。</p>
        </el-form-item>
        <div class="clear"></div>
        <el-form-item label="公司规模" class="formWidth">
          <el-select v-model="certForm.size" placeholder="请选择" :disabled='(status==2||status==3)?true:false'>
            <el-option v-for="item in companySize" :label="item" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司地址" >           
          <el-col :span="9" style="padding-right:5px;">
            <el-form-item>
              <el-cascader :options="areaOptions" style="width:100%" v-model="certForm.areaCode" @change="areaChange" :disabled='(status==2||status==3)?true:false'></el-cascader>
            </el-form-item>
          </el-col>          
          <el-col :span="15" style="padding-left:5px;">
            <el-form-item>
              <el-input v-model="certForm.address" placeholder="请输入详细地址" :disabled='(status==2||status==3)?true:false'></el-input>
            </el-form-item>
          </el-col>          
        </el-form-item>
        <el-form-item label="所属行业" class="formWidth">
          <el-cascader :options="industryOptions" style="width:100%" v-model="certForm.industryArr" @change="industryChange" :disabled='(status==2||status==3)?true:false'></el-cascader>
        </el-form-item>
        <el-form-item label="公司简介">
          <el-input type="textarea" rows="5" v-model="certForm.introduction" maxlength="500" show-word-limit placeholder="" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item>

        <el-form-item label="联系人" class="formWidth" prop="linkman" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-input v-model="certForm.linkman" placeholder="" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item>
        <el-form-item label="联系电话" class="formWidth" prop="linkphone" :rules="{required: true, validator:validatePhone, trigger: 'blur'}">
          <el-input v-model="certForm.linkphone" placeholder="" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item>
        <el-form-item label="联系邮箱" class="formWidth" prop="linkemail" :rules="{required: true, validator:validateEmail, trigger: 'blur'}">
          <el-input v-model="certForm.linkemail" placeholder="" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item>

        <div class="clear"></div>
        <el-form-item label="营业执照" class="formWidth" prop="fileone" :rules="{required: true, message: '必填', trigger: 'blur'}">
          <el-upload class="" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :disabled='(status==2||status==3)?true:false' :show-file-list="false" :http-request="changeImageUpload1" :before-upload="handleBeforeUpload">
            <el-image v-if="certForm.fileone" class="avatar" :src="imgBase+certForm.fileone" fit="scale-down"></el-image>
            <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
            <el-button v-else type="warning"><i class="fa fa-plus"></i> 上 传</el-button>
          </el-upload>
          <p class="placeholder">要求：请上传格式为jpg、jpeg、png、gif，小于1MB的图片。</p>
        </el-form-item>
        <div class="clear"></div>
        <!-- <el-form-item label="税务登记证" class="formWidth">
          <el-upload class="" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :disabled='(status==2||status==3)?true:false' :show-file-list="false" :http-request="changeImageUpload2" :before-upload="handleBeforeUpload">
            <el-image v-if="certForm.filetwo" class="avatar" :src="imgBase+certForm.filetwo" fit="scale-down"></el-image>
            <el-button v-else type="warning"><i class="fa fa-plus"></i> 上 传</el-button>
          </el-upload>
          <p class="placeholder">要求：请上传格式为jpg、jpeg、png、gif，小于1MB的图片。</p>
        </el-form-item>
        <div class="clear"></div>
        <el-form-item label="组织机构代码" class="formWidth">
          <el-upload class="" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :disabled='(status==2||status==3)?true:false' :show-file-list="false" :http-request="changeImageUpload3" :before-upload="handleBeforeUpload">
            <el-image v-if="certForm.filethree" class="avatar" :src="imgBase+certForm.filethree" fit="scale-down"></el-image>
            <el-button v-else type="warning"><i class="fa fa-plus"></i> 上 传</el-button>
          </el-upload>
          <p class="placeholder">要求：请上传格式为jpg、jpeg、png、gif，小于1MB的图片。</p>
        </el-form-item>
        <div class="clear"></div>
        <el-form-item label="一般纳税人证明" class="formWidth">
          <el-upload class="" action="" style="line-height: 0;" accept="image/png,image/gif,image/jpg,image/jpeg" :disabled='(status==2||status==3)?true:false' :show-file-list="false" :http-request="changeImageUpload4" :before-upload="handleBeforeUpload">
            <el-image v-if="certForm.filefour" class="avatar" :src="imgBase+certForm.filefour" fit="scale-down"></el-image>
            <el-button v-else type="warning"><i class="fa fa-plus"></i> 上 传</el-button>
          </el-upload>
          <p class="placeholder">要求：请上传格式为jpg、jpeg、png、gif，小于1MB的图片。</p>
        </el-form-item>
        <el-form-item label="需要的服务">
          <el-input v-model="certForm.helpinfo" placeholder="" :disabled='(status==2||status==3)?true:false'></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('certForm')" v-if="status==1||status==4"><i class="fa fa-check"></i> 提交认证</el-button>
          <!-- <el-button type="warning"><i class="fa fa-save"></i> 暂存</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    
  </div>
</template>
<script>
  import * as API from '@/api/main'
  import areaJs from '@/assets/js/select_area.js';
  import industryJs from '@/assets/js/select_industry.js';
export default {
  data(){
    return {
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      userInfo:JSON.parse(localStorage.getItem("user")),
      loading:false,
      certForm:{
        company:"",
        filelogo:"",
        linkman:"",
        linkphone:"",
        areaCode:[], //此处填写对应的value值['110000', '110100', '110108']
        area:"",
        industryArr:[],//行业
        industry:"",//
        fileone:"",//营业执照
        filetwo:"",//税务登记证
        filethree:"",//组织机构代码
        filefour:"",//一般纳税人证明
        // filefive:"",//营业执照
      },//企业认证表单
      companySize:["1-10人","11-50人","51-100人","101-499人","500-2000人","2000-10000人","10000人以上"],
      areaOptions: areajson, //调用外部js文件的json数据
      industryOptions:industryjson,//行业数据
      status:1,// 1未认证，2认证中，3认证成功，4认证失败
    }
  },
  methods: {

    areaChange(value) {
      if(value){
        console.log(value);
        console.log(value.toString());
        this.certForm.area=value.toString();
      }      
    },

    industryChange(value){
      if(value){
        this.certForm.industry=value.toString();
      }      
    },
    
    // 上传文件之前的钩子
    handleBeforeUpload(file){
      if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
          this.$message({
              type: 'warning',
              message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
          });
          return false;
      }
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      if(size > 1) {
          this.$message({
              type: 'warning',
              message: '图片大小必须小于1M'
          });
          return false;
      }
    },

    //图片上传
    changeImageUpload(options) {
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
        API.ImgUpload({filephoto:base64Str}).then(res => {
          this.certForm.filelogo=res.data.filepath;
        })
      }
    },

    //营业执照
    changeImageUpload1(options){
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
        API.ImgUpload({filephoto:base64Str}).then(res => {
          this.certForm.fileone=res.data.filepath;
        })
      }
    },

    //税务登记证
    changeImageUpload2(options){
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
        API.ImgUpload({filephoto:base64Str}).then(res => {
          this.certForm.filetwo=res.data.filepath;
        })
      }
    },

    //组织机构代码
    changeImageUpload3(options){
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
        API.ImgUpload({filephoto:base64Str}).then(res => {
          this.certForm.filethree=res.data.filepath;
        })
      }
    },

    //一般纳税人证明
    changeImageUpload4(options){
      let file = options.file
      let filename = file.name
      let fileReader = new FileReader();
      if (file) {
          fileReader.readAsDataURL(file)
      }
      fileReader.onload = () => {
          let base64Str = fileReader.result;
        API.ImgUpload({filephoto:base64Str}).then(res => {
          this.certForm.filefour=res.data.filepath;
        })
      }
    },

    //提交
    submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            API.Certificate(this.certForm).then(res=>{
              this.$message({
                message: res.info,
                type: 'success'
              });
              this.status=2;
              this.userInfo.status=2;
              localStorage.setItem('user',JSON.stringify(this.userInfo));
            })
          } else {
            return false;
          }
        });
    },

    //校验手机号码
    validatePhone(rule, value, callback) {
      let phoneReg1 = /^1[3456789]\d{9}$/; //大陆手机号验证
      // let phoneReg2 = /^852(5|6|8|9)\d{7}$/;    //香港手机号验证
      if (!value) {
        return callback(new Error('请输入手机号码')) ;
      }
      setTimeout(() => {
        if (!phoneReg1.test(value)) {
          callback(new Error('手机号码格式有误'));
        } else {
          callback();
        }
      }, 0)
    },

    //校验邮箱地址
    validateEmail(rule, value, callback) {
        let emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; //邮箱验证
        if (!value) {
          return callback(new Error('请输入邮箱')) ;
        }
        setTimeout(() => {
          if (!emailReg.test(value)) {
            callback(new Error('邮箱格式有误'));
          } else {
            callback();
          }
        }, 0)
      },

    //获取企业信息
    getInfo(){
      this.loading=true;
      API.GetCompanyInfo().then(res=>{
        this.certForm=res.data;
        if(this.certForm.area){
          this.certForm.areaCode=this.certForm.area.split(",");        
          this.certForm.area=this.certForm.areaCode.toString();
        }
        if(this.certForm.industry){
          this.certForm.industryArr=this.certForm.industry.split(",");
        }        
        if(this.userInfo.status!==this.certForm.status){
          this.userInfo.status=this.certForm.status;
          this.status=this.certForm.status;
          localStorage.removeItem('user');
          localStorage.setItem('user',JSON.stringify(this.userInfo));
        }
        this.loading=false;
      })
    }


  },
  created() {
    // console.log(JSON.parse(localStorage.getItem("user")))
    this.status=this.userInfo.status;
    if(this.status==1){
      this.certForm.linkman=this.userInfo.name;
      this.certForm.linkphone=this.userInfo.mobile;
      this.certForm.company=this.userInfo.company;
      if(this.certForm.areaCode){
        this.certForm.area=this.certForm.areaCode.toString();
      }
      
    }else{
      this.getInfo();      
    }    
    

  },
}
</script>
<style scoped>
  .formWidth{width:50%;display:inline-block;}
  .avatar-uploader-icon{font-size: 28px; color: #8c939d; width: 100px;height: 100px; line-height: 100px;text-align: center;}
  .el-image{width:100%;}
  .el-image img{max-width:100%;}
  .certForm .avatar-uploader .el-upload{width: 100%;;}
  @media screen and (max-width: 1200px){
    .formWidth{width:100%;}
  }
</style>